import { useContext } from 'react';

import {
  Theme,
  ThemeContext,
  ThemeContextType,
} from '../../../../contexts/ThemeContext/ThemeContext';

export interface UseHelp {
  theme: Theme;
}

const useHelp = (): UseHelp => {
  const { theme } = useContext<ThemeContextType>(ThemeContext);

  return {
    theme,
  };
};

export default useHelp;
